// eslint-disable-next-line import/prefer-default-export
export function initAccordions() {
  const buttons = document.querySelectorAll('.accordion .accordion__btn');

  buttons.forEach((btn) => {
    const panel = btn.nextElementSibling;
    if (!panel) {
      return;
    }
    const wrapper = btn.closest('.accordion__wrapper') || panel.parentElement;

    panel.style.maxHeight = '0px';

    btn.addEventListener('click', () => {
      const isOpen = wrapper ? wrapper.classList.toggle('is-open') : !panel.classList.contains('is-open');
      btn.classList.toggle('accordion__btn--active', isOpen);
      panel.classList.toggle('is-open', isOpen);

      if (isOpen) {
        panel.style.maxHeight = `${panel.scrollHeight}px`;
      } else {
        panel.style.maxHeight = '0px';
      }
    });
  });
}
